import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import BlockTitle from '../../../layout/BlockTitle';
import GrayBox from '../../../layout/GrayBox';
import { Button } from '../../../../common/Button';
import { sendDeleteRouterConfigurationRequest } from '../../../../../utils/api/routerAPI';
import UnlinkDeviceModal from '../UnlinkDeviceModal';
import styles from './RouterDeleteBlock.scss';

interface RouterDeleteBlockProps {
  routerId: string;
  onRouterDeleted: () => void;
}

const RouterDeleteBlock = ({ routerId, onRouterDeleted }: RouterDeleteBlockProps) => {
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  return (
    <article>
      <BlockTitle>
        <FormattedMessage id="profile.routerSection.deleteBlock.title" defaultMessage="Delete the device" />
      </BlockTitle>

      <GrayBox className={styles.box}>
        <p className={styles.text}>
          <FormattedMessage
            id="profile.routerSection.deleteBlock.text"
            defaultMessage="Deleting this device means you won’t be able to use VPN on your router. It might also cause temporary internet issues when the VPN disconnects"
          />
        </p>

        <Button
          buttonSize="small"
          className={styles.button}
          onClick={() => {
            setIsDeleteDialogVisible(true);
          }}
        >
          <FormattedMessage id="profile.routerSection.deleteBlock.button" defaultMessage="Delete" />
        </Button>
      </GrayBox>

      <UnlinkDeviceModal
        isRouter
        visible={isDeleteDialogVisible}
        onUnlink={() =>
          sendDeleteRouterConfigurationRequest(routerId).then(() => {
            onRouterDeleted();
          })
        }
        onCancel={() => {
          setIsDeleteDialogVisible(false);
        }}
      />
    </article>
  );
};

export default RouterDeleteBlock;
